import React, { useState, useEffect } from 'react';
import Modal from '../../components/layout/Modal';
import VBox from '../../components/layout/VBox';
import Grid, { GridItem } from '../../components/layout/Grid';
import CampoTexto from '../../components/Formulario/CampoTexto';
import AlertBox from '../../components/layout/AlertBox';
import { SeletorUsuarioGrupo } from '@/components/Formulario/SeletorUsuarioGrupo';

export type TransferenciaTicketData = {
    tipo: 'usuario' | 'grupo';
    destino_id: number;
    motivo: string;
};

export type ModalTransferirTicketProps = {
    show: boolean;
    onClose: () => void;
    onTransferir: (dados: TransferenciaTicketData) => void;
    ticketId: number;
};

export const ModalTransferirTicket = ({ show, onClose, onTransferir, ticketId }: ModalTransferirTicketProps) => {
    const [usuarioId, setUsuarioId] = useState<number | null>(null);
    const [grupoId, setGrupoId] = useState<number | null>(null);

    const [motivo, setMotivo] = useState('');

    // Reset form when modal opens
    useEffect(() => {
        if (show) {
            setUsuarioId(null);
            setGrupoId(null);
            setMotivo('');
        }
    }, [show]);

    const handleConfirm = () => {
        if ((!usuarioId && !grupoId) || !motivo.trim()) {
            return; // Validate fields
        }

        if (usuarioId)
            onTransferir({
                tipo: 'usuario',
                destino_id: usuarioId,
                motivo: motivo.trim(),
            });
        else if (grupoId) {
            onTransferir({
                tipo: 'grupo',
                destino_id: grupoId,
                motivo: motivo.trim(),
            });
        }
    };

    return (
        <Modal
            show={show}
            title="Transferir Ticket"
            onClose={onClose}
            onCancel={onClose}
            onConfirm={handleConfirm}
            confirmProps={{ disabled: (!usuarioId && !grupoId) || !motivo.trim() }}
        >
            <VBox gap="16px">
                <Grid>
                    <GridItem sm={12}>
                        <CampoTexto
                            instanceId="motivo"
                            label="Motivo da Transferência"
                            value={motivo}
                            onChange={setMotivo}
                            required
                            multiline
                            rows={3}
                        />
                    </GridItem>
                    <GridItem sm={12}>
                        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                            <p>Transferir para</p>
                            <SeletorUsuarioGrupo
                                usuarioId={usuarioId}
                                grupoId={grupoId}
                                onUsuarioIdChange={setUsuarioId}
                                onGrupoIdChange={setGrupoId}
                            />
                        </div>
                    </GridItem>
                </Grid>

                <AlertBox variant="info">
                    O ticket permanecerá visível (somente leitura) para o departamento de origem. O SLA não será reiniciado.
                </AlertBox>
            </VBox>
        </Modal>
    );
};
